document.addEventListener("turbo:load", function() {

  if($('.product-page__header-folder-image-container').length){
    // animate header image product page
    let folderTop = $('.product-page__header-folder-image-container')[0].offsetTop
    let openFolderAt = folderTop - $(window).innerHeight() / 0.75
    let closeFolderAt = folderTop

    if ($(window).innerWidth() > 768){
      $('#js-product-image--middle, #js-product-image--top').addClass('active')
    }

    $(window).off('scroll.productPage').on('scroll.productPage', function(event) {
      $('#js-product-image--middle, #js-product-image--top').toggleClass('active',
        (
          $(window).scrollTop() > openFolderAt
          && $(window).scrollTop() < closeFolderAt
        )
      );
    });
  }
});

